"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _avatar = _interopRequireDefault(require("./avatar"));

var _button = _interopRequireDefault(require("./button"));

var _icon_button = _interopRequireDefault(require("./icon_button"));

var _app_bar_panel = _interopRequireDefault(require("./shared/app_bar_panel"));

require("../css/user_profile.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserButton = function UserButton(_ref) {
  var active = _ref.active,
      image = _ref.image,
      name = _ref.name,
      onClick = _ref.onClick,
      title = _ref.title;

  if (image === null) {
    return _react.default.createElement("div", {
      className: "vn-user-profile__user-icon-button"
    }, _react.default.createElement(_icon_button.default, {
      active: active,
      icon: "profile",
      onClick: onClick,
      title: title
    }));
  }

  return _react.default.createElement("button", {
    className: "vn-user-profile__user-image-button",
    onClick: onClick,
    type: "button",
    title: title
  }, _react.default.createElement("img", {
    alt: name,
    src: image
  }));
};

UserButton.propTypes = {
  active: _propTypes.default.bool.isRequired,
  image: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  title: _propTypes.default.string.isRequired
};
UserButton.defaultProps = {
  image: null
};

var UserProfile = function UserProfile(_ref2) {
  var email = _ref2.email,
      i18n = _ref2.i18n,
      image = _ref2.image,
      name = _ref2.name,
      onEditMyProfileClick = _ref2.onEditMyProfileClick,
      onSignOutClick = _ref2.onSignOutClick,
      onToggleClick = _ref2.onToggleClick,
      show = _ref2.show;
  return _react.default.createElement(_app_bar_panel.default, {
    panelClassName: "vn-user-profile__panel",
    title: i18n.title,
    toggle: function toggle(onClick, active) {
      return _react.default.createElement(UserButton, {
        active: active,
        image: image,
        name: name,
        onClick: onClick,
        title: i18n.title
      });
    },
    show: show,
    onToggleClick: onToggleClick
  }, _react.default.createElement("div", {
    className: "vn-user-profile__avatar"
  }, image && _react.default.createElement(_avatar.default, {
    image: image,
    alt: name,
    ring: true
  }), !image && _react.default.createElement(_avatar.default, {
    alt: name,
    size: 72
  })), _react.default.createElement("div", {
    className: "vn-user-profile__content"
  }, _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "vn-user-profile__content-name",
    title: name
  }, name), _react.default.createElement("div", {
    className: "vn-user-profile__content-email",
    title: email
  }, email)), _react.default.createElement(_button.default, {
    className: "vn-user-profile__content-edit",
    appearance: "secondary",
    onClick: onEditMyProfileClick
  }, i18n.editMyProfile), _react.default.createElement("button", {
    className: "vn-user-profile__content-sign-out",
    onClick: onSignOutClick,
    title: i18n.signOut,
    type: "button"
  }, i18n.signOut)));
};

UserProfile.propTypes = {
  email: _propTypes.default.string.isRequired,
  show: _propTypes.default.bool,
  i18n: _propTypes.default.shape({
    editMyProfile: _propTypes.default.string.isRequired,
    signOut: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired
  }),
  image: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  onEditMyProfileClick: _propTypes.default.func.isRequired,
  onSignOutClick: _propTypes.default.func.isRequired,
  onToggleClick: _propTypes.default.func
};
UserProfile.defaultProps = {
  show: undefined,
  i18n: {
    editMyProfile: 'Edit My Profile',
    signOut: 'Sign Out',
    title: 'My Profile'
  },
  image: null,
  onToggleClick: function onToggleClick() {}
};
UserProfile.displayName = 'UserProfile';
var _default = UserProfile;
exports.default = _default;